// 默认头像
export const DEFAULT_AVATAR = '/static/images/lawyer.png';

// 头像上传图标
export const AVATAR_UPLOAD_ICON = '/static/images/avatar_upload_icon.png';

// 二维码到跳转到微信小程序的url
// export const QR_CODE_LINK = 'https://service.wusong.com/static/id?userId=';
export const QR_CODE_LINK = 'https://pro-passover-h5-project.wusong.com/examine?type=share&form=app&code=';

// 认证地址
export const CERTIFICATION_ADDRESS = 'https://service.wusong.com'; // 生产
// export const CERTIFICATION_ADDRESS = 'https://test.wusong.com';  // 测试

/**
 * @constant：静态图片存放地址
 */
export const ICON_EMAIL = '/static/images/icons/icon_email.png';
export const ICON_PHONE = '/static/images/icons/icon_phone.png';
export const ICON_HEADSET = '/static/images/icons/icon_headset.png';
export const BG_IMG = '/static/images/bg_calling_card_02.png';
// 白色向左箭头
export const ARROW_LEFT_WHITE = '/static/images/arrow_left_white.png';
// 灰色向左箭头
export const ARROW_LEFT = '/static/images/left.png';

export const SERVICE_TELPHONE = '400-010-5353'; // 客服电话
